import { createReducer, on } from '@ngrx/store';
import * as BusLineActions from '../../actions/master-data/busline.actions';
import { BusLineState } from '../../states/master-data/busline.state';

export const initialState: BusLineState = {loading: false, busLines: [], error: undefined, successMessage: ''};

export const busLineReducer = createReducer(
    initialState,
    on(BusLineActions.loadBusLines, (state) => ({ ...state, loading: true, successMessage: '', error: null })),
    on(BusLineActions.addBusLineSuccess, (state, {  message }) => ({
        ...state,
        successMessage: message,
        error: null
      })),
    on(BusLineActions.loadBusLinesSuccess, (state, {busLines}) => ({ ...state, loading: false, busLines })),
    on(BusLineActions.addBusLine, (state, {busLine}) => ({...state, busLines: [...state.busLines, busLine]})),
    on(BusLineActions.updateBusLine, (state, {busLine}) => ({...state, busLines: state.busLines.map(r => r.id === busLine.id ? busLine : r)})),
    on(BusLineActions.updateBusLineSuccess, (state, { message }) => ({
      ...state,
      successMessage: message ?? 'Bus line updated successfully'
    })),
    on(BusLineActions.deleteBusLine, (state, {id}) => ({...state, busLines: state.busLines.filter(r => r.id !== id)})),
    on(BusLineActions.deleteBusLineSuccess, (state, { message }) => ({
      ...state,
      successMessage: message ?? 'Bus line deleted successfully'
    })),
    on(BusLineActions.loadBusLineFailure, (state, { error }) => ({ ...state, loading: false, error })),
);